import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { getWashingMethod, updateWashingMethod } from '@/apis/washingMethods'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { UpdateOperatorResponse } from '@/types/apis/operators/UpdateOperatorResponse'
import { GetWashingMethodRequest } from '@/types/apis/washingMethods/GetWashingMethodRequest'
import { GetWashingMethodResponse } from '@/types/apis/washingMethods/GetWashingMethodResponse'
import { UpdateWashingMethodRequest } from '@/types/apis/washingMethods/UpdateWashingMethodRequest'

export const useUpdateWashingMethods = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<UpdateOperatorResponse>()

  const update = useCallback(
    async (request: UpdateWashingMethodRequest) => {
      try {
        setLoading(true)
        const res = await updateWashingMethod(request)
        setResponse(res)
        openNotification({ type: 'success', description: t('components.pages.admins.common.update.success') })
        navigate(routes.washingMethods.path)
      } catch {
        openNotification({ type: 'error', description: t('components.pages.admins.common.update.fail') })
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    updateWashingMethod: update,
    response,
  }
}

export const useGetWashingMethod = () => {
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<GetWashingMethodResponse>()

  const get = useCallback(async (request: GetWashingMethodRequest) => {
    try {
      setLoading(true)
      const res = await getWashingMethod(request)
      setResponse(res)
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    loading,
    getWashingMethod: get,
    response,
  }
}
